export default function GroupRowInnerRenderer () {}

GroupRowInnerRenderer.prototype.init = function(params) {
    this.eGui = document.createElement('div');
    this.eGui.style.display = "contents";
    this.params = params;
    this.refreshGui();

    var that = this;
    this.dataChangedListener = function() {
        that.refreshGui();
    };

    params.api.addEventListener('cellValueChanged', this.dataChangedListener);
    params.api.addEventListener('filterChanged', this.dataChangedListener);
};

GroupRowInnerRenderer.prototype.refreshGui = function() {
    // var flagCode = this.params.flagCodes[this.params.node.key];

    // var html = '';
    // if (flagCode) {
    //     html += '<img class="flag" border="0" width="20" height="15" src="https://flags.fmcdn.net/data/flags/mini/' + flagCode + '.png">';
    // }

    var html='';
    var node = this.params.node;
    var aggData = node.aggData;
    var keys = Object.keys(aggData);

    var selectedMetricDisp = this.params.node.gridOptionsWrapper.gridOptions.metricsObject;

    html += '<span class="groupTitle"> COUNTRY_NAME</span>'.replace('COUNTRY_NAME', node.key);
    selectedMetricDisp.map(function(innerData,index)  {
        // if(innerData.isAggregate=="1"){
            let valObj = innerData.value;
        
            var value = aggData[valObj];
            
            if (value)
                value = value.toString();
            roundOff = innerData.roundOff;
            $roundOff = parseInt(roundOff);
            
            if (typeof value == 'string') {
                if(value=="*")
                    value=0;
                
                value = value == undefined || value == '' ? 0 : number_shorten(value.toString(), innerData.roundOff, innerData.numberShorten);
            }

            html += '<span class="label label-default margin-padding-tags"> ' + innerData.label + ' ' + value + '</span>';   
        // }
    })

    this.eGui.innerHTML = html;
};

GroupRowInnerRenderer.prototype.destroy = function() {
    this.params.api.removeEventListener('cellValueChanged', this.dataChangedListener);
    this.params.api.removeEventListener('filterChanged', this.dataChangedListener);
};

GroupRowInnerRenderer.prototype.getGui = function() {
    return this.eGui;
};